'use client'

import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Flex } from '@chakra-ui/react'
import { Region } from '@leid/api-locations'
import { useRouter } from 'next/navigation'

import { RegionWithAvailability } from 'app/components/pages/products/ProductInfoAndRentalSection/components/RentalSection/components/LocationsSelector'
import { CustomerInfo } from 'app/utils/authentication'
import apiClient from 'helpers/clients/apiClient'
import { Container } from 'styles/shared'

import { RegionsList } from './RegionsList'

type Props = {
  customerInfo: CustomerInfo | undefined
}

export const FooterRegionsList = ({ customerInfo }: Props): JSX.Element | null => {
  const { t } = useTranslation(['common', 'newsletter'])

  const router = useRouter()

  const [regions, setRegions] = React.useState<RegionWithAvailability[]>([])

  const isUserInNewsletter = customerInfo?.customer?.newsletterSubscription
  if (isUserInNewsletter) {
    return null
  }

  const handleRedirectToRegionPage = (region: Region | undefined) => {
    if (!region?.id) {
      return
    }

    const url = `/regions/${region.id}`

    router.push(url)
  }

  const populateRegions = async (): Promise<void> => {
    if (!customerInfo?.customer) {
      return
    }

    const response = await apiClient.getRegions({ active: true, allData: true }, undefined, {
      latitudeCoordinate: customerInfo.customer?.coordinates?.latitude,
      longitudeCoordinate: customerInfo.customer?.coordinates?.longitude,
    })

    if (response.success && response.data) {
      setRegions(response.data.rows.map<RegionWithAvailability>((s) => ({ ...s, hasAvailableLocations: true })))
    }
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    populateRegions()
  }, [])

  return (
    <Box backgroundColor="green.a150" paddingY={{ base: '28px', md: '54px' }}>
      <Container>
        <Flex
          justifyContent="space-between"
          alignItems={{ md: 'center' }}
          flexDirection={{ base: 'column', md: 'row' }}
        >
          <Box width={{ base: '100%' }}>
            {/* <Heading
              as="h3"
              color="white"
              fontWeight="normal"
              marginBottom={{ base: '16px', md: 0 }}
              fontSize={{ base: 'lg', md: '2xl' }}
              lineHeight={{ base: 1.33, md: 1.2 }}
            >
              {t('common:regions')}
            </Heading> */}
            <Box>
              {customerInfo && (
                <RegionsList
                  title={t('common:hereAreWe')}
                  regions={regions}
                  selectedRegionId={undefined}
                  onRegionChange={handleRedirectToRegionPage}
                  customerInfo={customerInfo}
                />
              )}
            </Box>
          </Box>
        </Flex>
      </Container>
    </Box>
  )
}
